/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { memo, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import LoginView from './login.view';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { logInAsync, selectAuth } from './auth.slice';
import { getSettingsAsync, selectSettings } from '../settings/settings.slice';
import { actions as appActions } from '../app/app.slice';

export interface ILoginContainer {}

const LoginContainer: React.FC<ILoginContainer> = ({}: ILoginContainer) => {
  const auth = useAppSelector(selectAuth);
  const settings = useAppSelector(selectSettings);
  const dispatch = useAppDispatch();
  const history = useHistory();

  useEffect(() => {
    if (auth.isAuthenticated) history.push('/');
  }, [auth.isAuthenticated]);

  useEffect(() => {
    dispatch(getSettingsAsync([]));
  }, []);

  useEffect(() => {
    dispatch(appActions.setLocationCode('10100'));
  }, []);

  const handleSingnIn = (data: unknown) => {
    dispatch(logInAsync(data));
  };

  const handleForgotPassword = () => {
    history.push('/forgotpassword');
  };
  return (
    <LoginView
      handleSingnIn={handleSingnIn}
      handleForgotPassword={handleForgotPassword}
      generalSettings={settings?.data?.general}
    />
  );
};

export default memo(LoginContainer);
